// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3w5di","insightsList":"newBusinessInsightsMenu_insightsList__Aks-K","active":"newBusinessInsightsMenu_active__3BsVd"};